import sign from "jwt-encode"

import EnvHelper from "@/utils/env-helper"
import { IMockLoginJWT, IStringHelper } from "@/utils/types/string-helper"

class StringHelper implements IStringHelper {
  mockLoginJWT({ uid, env, exp }: IMockLoginJWT): string {
    return sign(
      {
        exp,
        iat: 0,
        name: "Root",
        sub: env,
        uid,
        dest: import.meta.env.VITE_MOCK_DOMAIN,
      },
      EnvHelper.shopifyApiKey || "",
    )
  }

  generateRandomString(len: number): string {
    const chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_"
    const value: string[] = []
    const charsLen = chars.length

    for (let i = 0; i < len; i++) {
      value.push(chars.charAt(Math.floor(Math.random() * charsLen)))
    }

    return value.join("") + Date.now().toString()
  }

  /**
   * 转换富文本
   * @param text
   * @param isAdmin
   * @constructor
   */
  parseRichText(richText: string, isAdmin?: boolean) {
    // 被识别为空
    if (richText === "<p></p>") return ""

    // 去除li与a之间的换行符号（翻译后会出现）
    // let format = richText.replaceAll("<li>\n<a href=", "<li><a href=")
    const format = richText
    // 是否为后台预览状态，后台预览状态只能跳转新标签页（Shopify规则）

    return isAdmin
      ? format.replaceAll('target="_self"', 'target="_blank"')
      : format
  }

  /**
   * 截取字符串 当select组件字符过长时用省略号展示
   */
  TruncateString(inputString, maxLength) {
    if (inputString.length > maxLength) {
      return inputString.slice(0, maxLength) + "..."
    }
    return inputString
  }

  /**
   * 文本加密，前后展示，中间星号展示
   */

  maskString(str, preNum, endNum) {
    if (str.length <= preNum + endNum) {
      return str // 如果字符串长度不足总位数，直接返回原字符串
    }
    const prefix = str.slice(0, preNum) // 提取前6位
    const suffix = str.slice(-endNum) // 提取后6位
    const masked = "*".repeat(str.length - 12) // 中间部分用*替代
    return `${prefix}${masked}${suffix}`
  }
}

export default new StringHelper()
